// Colormap catalog shared by the legend CSS bar and the mesh fragment
// shader (via numeric glslId). Keep CSS stops visually aligned with the
// GLSL applyColormap() branches in mesh-tile-layer.js.

function cssGradient(stops) {
  // stops: [[0..1, color], ...] low → high (legend draws bottom→top)
  const parts = stops
    .map(([t, c]) => `${c} ${(t * 100).toFixed(3)}%`)
    .join(', ');
  return `linear-gradient(to top, ${parts})`;
}

function cmap(id, label, glslId, stops) {
  return {id, label, glslId, stops, css: cssGradient(stops)};
}

export const COLORMAPS = [
  cmap('jet', 'Jet', 0, [
    [0, 'rgb(0,0,128)'],
    [0.125, 'rgb(0,0,255)'],
    [0.25, 'rgb(0,128,255)'],
    [0.375, 'rgb(0,255,255)'],
    [0.5, 'rgb(128,255,128)'],
    [0.625, 'rgb(255,255,0)'],
    [0.75, 'rgb(255,128,0)'],
    [0.875, 'rgb(255,0,0)'],
    [1, 'rgb(128,0,0)']
  ]),
  cmap('blues', 'Blues', 1, [
    [0, '#f7fbff'],
    [0.125, '#deebf7'],
    [0.25, '#c6dbef'],
    [0.375, '#9ecae1'],
    [0.5, '#6baed6'],
    [0.625, '#4292c6'],
    [0.75, '#2171b5'],
    [0.875, '#08519c'],
    [1, '#08306b']
  ]),
  cmap('blues_r', 'Blues (reversed)', 2, [
    [0, '#08306b'],
    [0.125, '#08519c'],
    [0.25, '#2171b5'],
    [0.375, '#4292c6'],
    [0.5, '#6baed6'],
    [0.625, '#9ecae1'],
    [0.75, '#c6dbef'],
    [0.875, '#deebf7'],
    [1, '#f7fbff']
  ]),
  cmap('reds', 'Reds', 3, [
    [0, '#fff5f0'],
    [0.125, '#fee0d2'],
    [0.25, '#fcbba1'],
    [0.375, '#fc9272'],
    [0.5, '#fb6a4a'],
    [0.625, '#ef3b2c'],
    [0.75, '#cb181d'],
    [0.875, '#a50f15'],
    [1, '#67000d']
  ]),
  cmap('reds_r', 'Reds (reversed)', 4, [
    [0, '#67000d'],
    [0.125, '#a50f15'],
    [0.25, '#cb181d'],
    [0.375, '#ef3b2c'],
    [0.5, '#fb6a4a'],
    [0.625, '#fc9272'],
    [0.75, '#fcbba1'],
    [0.875, '#fee0d2'],
    [1, '#fff5f0']
  ]),
  cmap('viridis', 'Viridis', 5, [
    [0, '#440154'],
    [0.25, '#3b528b'],
    [0.5, '#21918c'],
    [0.75, '#5ec962'],
    [1, '#fde725']
  ]),
  cmap('plasma', 'Plasma', 6, [
    [0, '#0d0887'],
    [0.25, '#7e03a8'],
    [0.5, '#cc4778'],
    [0.75, '#f89540'],
    [1, '#f0f921']
  ]),
  cmap('turbo', 'Turbo', 7, [
    [0, '#30123b'],
    [0.2, '#4662d7'],
    [0.4, '#1ae4b6'],
    [0.6, '#a2fc3c'],
    [0.8, '#faba39'],
    [1, '#7a0403']
  ]),
  cmap('coolwarm', 'Cool–Warm', 8, [
    [0, '#3b4cc0'],
    [0.25, '#7b9ff9'],
    [0.5, '#dddcdc'],
    [0.75, '#f4915b'],
    [1, '#b40426']
  ]),
  cmap('inferno', 'Inferno', 9, [
    [0, '#000004'],
    [0.25, '#57106e'],
    [0.5, '#bc3754'],
    [0.75, '#f98c0a'],
    [1, '#fcffa4']
  ]),
  cmap('cividis', 'Cividis', 10, [
    [0, '#00224e'],
    [0.25, '#123e6b'],
    [0.5, '#5b7c8b'],
    [0.75, '#a9b574'],
    [1, '#f9e048']
  ]),
  cmap('gray', 'Grayscale', 11, [
    [0, '#000000'],
    [1, '#ffffff']
  ]),
  cmap('gray_r', 'Grayscale (reversed)', 12, [
    [0, '#ffffff'],
    [1, '#000000']
  ]),
  // Classic topo/bathy: land (neg) brown → white at 0 → deep ocean blue.
  // Pair with a domain centered on 0 so white lands on sea level.
  cmap('topo_bathy', 'Topo–Bathy', 13, [
    [0, '#5c3317'],
    [0.15, '#8b5a2b'],
    [0.3, '#c4a574'],
    [0.42, '#e8dcc8'],
    [0.5, '#ffffff'],
    [0.58, '#c8e0f0'],
    [0.7, '#6baed6'],
    [0.85, '#2171b5'],
    [1, '#08306b']
  ])
];

export const DEFAULT_COLORMAP_ID = 'jet';

export function getColormap(id) {
  return COLORMAPS.find(c => c.id === id) || COLORMAPS[0];
}
